import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ComingSoonModal } from './ComingSoonModal';

export const Marquee: React.FC = () => {
  const [showComingSoon, setShowComingSoon] = useState(false);

  const handleBuyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Buy button clicked'); // Debug log
    setShowComingSoon(true);
    setTimeout(() => setShowComingSoon(false), 1500);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 py-3 md:py-4 3xl:py-5 4xl:py-6 5xl:py-7 bg-oled/90 backdrop-blur-md border-t border-white/5 z-40 overflow-hidden">
      <div className="flex whitespace-nowrap">
        <motion.div
          className="flex gap-6 md:gap-8 3xl:gap-12 4xl:gap-16 5xl:gap-20 items-center"
          animate={{ x: ["0%", "-50%"] }}
          transition={{ 
            duration: 40, 
            repeat: Infinity, 
            ease: "linear" 
          }}
        >
          {/* Duplicated text for seamless loop */}
          {[...Array(6)].map((_, i) => (
            <React.Fragment key={i}>
              <span className="text-neutral-600 text-xs md:text-xs 3xl:text-sm 4xl:text-base 5xl:text-lg font-light tracking-widest lowercase">zzz... sleeping...</span>
              <button
                onClick={handleBuyClick}
                className="text-danger/70 text-xs md:text-xs 3xl:text-sm 4xl:text-base 5xl:text-lg font-light tracking-widest lowercase hover:text-danger transition-colors cursor-pointer relative z-50"
                style={{ pointerEvents: 'auto' }}
              >
                buy $1pct
              </button>
              <span className="text-neutral-600 text-xs md:text-xs 3xl:text-sm 4xl:text-base 5xl:text-lg font-light tracking-widest lowercase">low battery...</span>
              <div className="w-0.5 h-0.5 md:w-1 md:h-1 3xl:w-1.5 3xl:h-1.5 4xl:w-2 4xl:h-2 5xl:w-2.5 5xl:h-2.5 rounded-full bg-neutral-800"></div>
            </React.Fragment>
          ))}
        </motion.div>
      </div>
      
      {/* Coming soon modal */}
      <ComingSoonModal isVisible={showComingSoon} />
    </div>
  );
};